export default __webpack_public_path__ + "static/media/Perseverance.c70e4120.png";